import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AssetsService, SponsorAssetText } from '../../../infrastructure/services/assets.service';
import { LoaderService } from '../../../infrastructure/services/loader.service';
import { Translator } from 'angular-translator';
import { PortalTemplatesService, AliasChannel } from '../../../infrastructure/services/portalTemplates.service';

@Component({
  templateUrl: 'alias.channel.component.html'
})
export class AliasChannelComponent implements OnInit {
  codSubscription: string;
  codChannel: string;
  alias: AliasChannel;
  errores = {
    codAlias: null,
  };

  constructor(private aRoute: ActivatedRoute,
              private router: Router,
              private portalService: PortalTemplatesService,
              private translator: Translator) { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.codSubscription = params['codsistema'];
      this.codChannel = params['codnegocio'];

      this.portalService.getChannelAlias(this.codSubscription, this.codChannel)
        .then(res => {
          this.alias = {
            codSubscription: this.codSubscription,
            codChannel: this.codChannel,
            codAlias: res.codAlias,
          };
        });
    });
  }

  guardar() {
    if (this.datosValidos()) {
      this.portalService.createChannelAlias(this.alias)
        .then(res => {
          this.router.navigate(['./', 'template'], { relativeTo: this.aRoute });
        });
    }
  }

  private datosValidos() {
    let esValido = true;

    // reseteo los errores antes de checkear nuevamente
    this.resetearErrores();

    if (this.alias.codAlias === null || this.alias.codAlias.length <= 0) {
        this.errores['codAlias'] = <string>this.translator.instant('VALOR_REQUERIDO');
        esValido = false;
    }

    return esValido;
  }

  private resetearErrores() {
    Object.keys(this.errores).forEach(key => this.errores[key] = null);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/channels/alias/alias.channel.component.ts